import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoadPageComponent } from './pages/load-page/load-page.component';
import { PaymentPageComponent } from './pages/payment-page/payment-page.component';
import { SessionsGuard } from '@modules/guards/sessions.guard';
import { WebstoreConfirmationComponent } from './pages/webstore-confirmation/webstore-confirmation.component';

const routes: Routes = [
  {
    path: 'load',
    component: LoadPageComponent,
  },
  {
    path: 'card-payment',
    component: PaymentPageComponent,
    canActivate: [SessionsGuard],
  },
  {
    path: 'store-confirmation',
    component: WebstoreConfirmationComponent,
  },
  // ** REFERENCIA RUTAS QUE NO ESTAN DEFINIDAS
  // {
  //   path: '**',
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentsRoutingModule {}
